<template>
  <div class="supply">
    <div>
      <h2>
        <!-- 供需对接 -->
        <div>
          <img v-lazy="hrefurl+'/public/home/title%26bg/homeSupply.png'" alt="" />
        </div>
      </h2>
      <div class="content">
        <RollingCard :list='supplyList'/>
        <RollingCard :list='procurementList'/>
      </div>
    </div>
  </div>
</template>

<script>
import RollingCard from "../../../components/pc/rollingCard";
import { reqSupply } from '../../../api/index'
export default {
  components: {
    RollingCard,
  },
  data () {
    return {
      supplyList:{},   //供应
      procurementList:{},    //采购
    }
  },
  mounted(){
    this.addSupply()
    this.addprocurement()
  },
  methods:{
    async addSupply(){
      const response = await reqSupply("gong")
      if(response.code==0){
        response.resilt.forEach(item => {
          if(item.content.length>42)
            item.content = item.content.slice(0,42)+"......"
        });
        this.supplyList={name:"供应信息",list:response.resilt,key:'gong'}
      }
    },
    async addprocurement(){
      const response = await reqSupply("xu")
      if(response.code==0){
        response.resilt.forEach(item => {
          if(item.content.length>42)
            item.content = item.content.slice(0,42)+"......"
        });
        this.procurementList={name:"采购信息",list:response.resilt,key:'xu'}
      }
    }
  }
}
</script>

<style scoped>
  .supply{
    background: #ffffff url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/title&bg/homeSupplyBg.jpg') no-repeat top center;
    background-size: 100% 100%;
    height: 936px;
  }
  .supply>div{
    /* background-color: white; */
    padding-bottom: 60px;
    max-width: 1200px;
    margin: auto;
  }
  h2{
    text-align: center;
    padding: 70px 0 50px 0;
    font-size: 40px;
    color: #494c4d;
  }
  h2>div{
    width: 300px;
    height: 80px;
    overflow: hidden;
    margin: 0 auto;
  }
  .content{
    display: flex;
    justify-content: space-around;
    height: auto;
  }
 
</style>